import { useEffect } from "react";

// Marketing integrations — all optional and env-gated. Set the IDs in
// frontend/.env and the tags activate on the next build/restart:
//   REACT_APP_META_PIXEL_ID        Meta (Facebook/Instagram) Ads pixel
//   REACT_APP_GTAG_ID              Google Ads / Analytics tag (AW-… or G-…)
//   REACT_APP_TRUSTPILOT_BU_ID     Trustpilot Business Unit ID (footer widget)
//   REACT_APP_GOOGLE_REVIEWS_URL   Google Business Profile review link (footer)
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const GTAG_ID = process.env.REACT_APP_GTAG_ID;
const TRUSTPILOT_BU_ID = process.env.REACT_APP_TRUSTPILOT_BU_ID;
const GOOGLE_REVIEWS_URL = process.env.REACT_APP_GOOGLE_REVIEWS_URL;

export function TrackingScripts() {
  useEffect(() => {
    if (GTAG_ID) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", GTAG_ID);
    }
    if (META_PIXEL_ID) {
      /* Meta Pixel — standard bootstrap */
      const n = (window.fbq = window.fbq || function fbq() { n.queue.push(arguments); });
      n.queue = n.queue || [];
      n.loaded = true;
      n.version = "2.0";
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
      window.fbq("init", META_PIXEL_ID);
      window.fbq("track", "PageView");
    }
    if (TRUSTPILOT_BU_ID && !document.querySelector('script[src*="tp.widget.bootstrap"]')) {
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      document.head.appendChild(s);
    }
  }, []);
  return null;
}

export function TrustBoxMini() {
  if (!TRUSTPILOT_BU_ID) return null;
  return (
    <div
      className="trustpilot-widget mt-6"
      data-locale="en-IN"
      data-template-id="5419b6a8b0d04a076446a9ad"
      data-businessunit-id={TRUSTPILOT_BU_ID}
      data-style-height="24px"
      data-style-width="220px"
      data-theme="dark"
      data-testid="trustpilot-widget"
    >
      <a href="https://in.trustpilot.com/review/loansalaah.com" target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
}

export function GoogleReviewLink() {
  if (!GOOGLE_REVIEWS_URL) return null;
  return (
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="footer-google-reviews-link"
      className="mt-4 inline-block text-xs font-semibold text-ivory/70 underline decoration-brass/50 underline-offset-4 transition-colors hover:text-brass"
    >
      Review us on Google
    </a>
  );
}

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.03a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.07.81.82-3-.2-.31a8.08 8.08 0 0 1-1.24-4.31c0-4.47 3.65-8.12 8.12-8.12a8.1 8.1 0 0 1 8.11 8.12c0 4.48-3.64 8.12-8.11 8.12zm4.45-6.08c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.53.06-.24-.12-1.03-.38-1.96-1.21-.72-.65-1.21-1.44-1.36-1.68-.14-.24-.01-.37.11-.5.11-.11.24-.28.37-.42.12-.14.16-.24.24-.4.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.31-.22.24-.86.84-.86 2.05 0 1.21.88 2.37 1 2.53.12.16 1.72 2.63 4.18 3.69.58.25 1.04.4 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.05.14-1.16-.06-.1-.22-.16-.46-.28z" />
  </svg>
);

export function WhatsAppFloat() {
  const text = encodeURIComponent("Hi Loan Salaah, I'd like advice on a loan or credit card.");
  return (
    <a
      href={`https://wa.me/919953773246?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-chat-button"
      aria-label="Chat with Loan Salaah on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110"
    >
      <WhatsAppIcon />
    </a>
  );
}
